var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "brochure" }, [
    _c("div", { staticClass: "brochure__image" }, [
      _c("picture", [
        _c("img", {
          attrs: {
            src: `${_vm.brochure.imageUrl}?format=webp`,
            alt: _vm.brochure.name,
            loading: "lazy",
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("h4", { staticClass: "brochure__title" }, [
      _vm._v(_vm._s(_vm.brochure.name)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "brochure__code" }, [
      _vm._v(_vm._s(_vm.brochure.code)),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "brochure__description" }, [
      _vm._v(_vm._s(_vm.brochure.description)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "brochure__actions" }, [
      _vm.brochure.canPost
        ? _c(
            "div",
            {
              staticClass:
                "brochure__post default-checkbox default-checkbox--alt",
            },
            [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected,
                      expression: "selected",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.selected)
                      ? _vm._i(_vm.selected, null) > -1
                      : _vm.selected,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.selected,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.selected = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.selected = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "checkbox__label" }, [
                  _vm._v("Order by post"),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.brochure.canDownload
        ? _c(
            "a",
            {
              ref: "modal",
              staticClass: "brochure__online",
              attrs: { href: "#popup" },
              on: {
                click: function ($event) {
                  return _vm.$emit("brochureSelected", _vm.brochure)
                },
              },
            },
            [_vm._v("\n      View online\n    ")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }